import { AbstractControl, ValidatorFn, ValidationErrors } from "@angular/forms";

export function jsonValue(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const controlValue = control.value;
    if (!controlValue) {
      return null;
    }
    try {
      JSON.parse(controlValue);
      return null;
    } catch {
      return { invalidJson: true };
    }
  };
}
